import React from "react";
import ModalHeader1 from "../../../images/lbs/wave (1).svg";
import ModalHeader from "../../../images/lbs/wave.svg";
import ModalHeader2 from "../../../images/lbs/wave (2).svg";
import ModalHeader3 from "../../../images/lbs/wave (4).svg";
import { checkValue, getFiledValue } from "../../../constant/helper";
import { message } from "antd";

function MarkerInfoHeader({ data: pinData }) {
  function shareDate() {
    const { title, summary, metaData } = pinData;

    let shareData = {
      title: getFiledValue(title).join(""),
      text: `
        ${getFiledValue(summary).join("")}
        آدرس: ${metaData.address}
        وب سایت: ${metaData.website}
      `,
      url:
        metaData && metaData.website && checkValue(metaData.website)
          ? metaData.website
          : window.location.href,
    };

    if (navigator.share) {
      navigator
        .share(shareData)
        .then(() => {})
        .catch((error) => {
          message.error("خطایی در اشتراک گذاری رخ داد! لطفا مجددا تلاش نمائید");
        });
    } else {
      message.error("سیستم عامل دستگاه شما، قابلیت اشتراک گذاری را ندارد!");
    }
  }

  return (
    <div className="header-wrapper">
      {navigator && navigator.share && pinData && (
        <div className="share-button" onClick={shareDate}>
          <span className="icon-share" />
        </div>
      )}

      <img
        src={ModalHeader1}
        alt="header"
        className="info-header"
        style={{ zIndex: 2 }}
      />
      <img
        src={ModalHeader}
        alt="header"
        className="info-header"
        style={{ zIndex: 2 }}
      />
      <img
        src={ModalHeader2}
        alt="header"
        className="info-header"
        style={{ zIndex: 1, top: "-12ch" }}
      />
      <img
        src={ModalHeader3}
        alt="header"
        className="info-header"
        style={{ zIndex: 1, top: "-14ch" }}
      />
    </div>
  );
}

export default MarkerInfoHeader;
